import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { CriterionAverageItem, QualityKpis } from '@/entities/dashboards';
import { KpiCard } from './parts/KpiCard';
import { criteriaExtremesByRatio, fmt } from './utils';

type Props = {
  kpis: QualityKpis;
  /** Средние по видимым (не скрытым) критериям — источник KPI «Проблемный критерий». */
  visibleCriteriaAverages: CriterionAverageItem[];
};

/**
 * Верхний ряд метрик дашборда: средний балл, количество оценок, консультантов,
 * процент низких и проблемный критерий. Рендерится только при наличии оценок.
 */
export const KpiRow: FC<Props> = ({ kpis, visibleCriteriaAverages }) => {
  const { t } = useTranslation('qualityDashboard');

  // «Проблемный критерий» — критерий (блок верхнего уровня) с наименьшей долей балла от максимума
  // своей шкалы среди видимых (не скрытых), а не с наименьшим абсолютным средним: критерий с короткой
  // шкалой у потолка не должен всплывать проблемным лишь из-за малого абсолюта.
  // Учитываются только критерии с определимым максимумом; скрытие критерия убирает его и из этого KPI;
  // если подходящих критериев нет — прочерк.
  const worstCriterion = criteriaExtremesByRatio(visibleCriteriaAverages).weakest?.name ?? '—';

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 2xl:grid-cols-5 gap-3">
      <KpiCard label={t('kpi.avgScore')} value={fmt(kpis.avgTotal)} />
      <KpiCard label={t('kpi.evaluationsCount')} value={String(kpis.count)} />
      <KpiCard label={t('kpi.consultantsCount')} value={String(kpis.consultantsCount)} />
      <KpiCard label={t('kpi.lowScorePct')} value={`${fmt(kpis.lowPct, 0)}%`} />
      <KpiCard label={t('kpi.worstCriterion')} value={worstCriterion} compact />
    </div>
  );
};
